import { render, staticRenderFns } from "./newSale.vue?vue&type=template&id=3b6690b4&"
import script from "./newSale.vue?vue&type=script&lang=ts&"
export * from "./newSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports